"use client";

import styled, { css } from "styled-components";
import { screens } from "./globalsStyles";

export const ItemsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
  justify-content: center;

  ${screens({
    desktop: css`
      gap: 1rem;
    `,
    mobile: css`
      gap: 0.5rem;
    `
  })}
`;
